import { clsx } from 'clsx';

/**
 * Estilos compartidos de los controles de formulario de MasterDocument.
 *
 * Viven aquí y no dentro de `FieldRenderer` porque había DOS copias de
 * `readonlyBase` —una en `FieldRenderer` y otra en `LookupReadonlyValue`— y
 * divergieron: la primera pasó a `flex items-center h-10` (§D.2, el alto del
 * control editable) y la segunda se quedó en `py-1.5`. Medido en dev el
 * 2026-09-09 sobre el modal de línea de una devolución de venta, pestaña
 * «Centros y Dimensiones»: los tres campos searcher de sólo lectura y sin dato
 * medían **12px de alto** —el padding y nada más— mientras sus vecinos con
 * texto medían 40. La rejilla del formulario quedaba dentada.
 *
 * `FieldRenderer` no puede exportarlos porque importa `LookupReadonlyValue`, y
 * la importación al revés cerraría el ciclo.
 */

/**
 * Alto de control del canon (§D.2): `h-10` (40px) para todo control de UNA
 * línea. NO se mete en `inputBase` porque ahí lo heredaría también el
 * `textarea`, que es multilínea y tiene su propio `min-h-[72px]`.
 */
export const controlHeight = 'h-10';

/**
 * Caja de un valor en SOLO LECTURA. Mismo alto que el control editable: si
 * difiere, la rejilla salta al pasar de vista a edición y las dos lecturas del
 * formulario no cuadran. `flex items-center` es lo que centra el texto dentro
 * de esos 40px y lo que sostiene la altura cuando el valor está vacío.
 */
export const readonlyBase = clsx(
  'flex items-center w-full h-10 rounded-md bg-background-secondary px-3 text-sm text-content-primary select-none',
  'dark:bg-dark-bg-secondary dark:text-dark-content-primary',
);
